<script setup lang="ts">
import { onMounted, watch } from "vue";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import ForceChangePasswordHost from "@app/components/ForceChangePasswordHost.vue";
import { useBrandOptionsStore } from "@app/store/modules/brandOptions";
import { useCurrentUserStore } from "@app/store/modules/currentUser";
import { useStoreSitesStore, useUserOptionsStore } from "@app/store/options";
import { useAsyncTaskStore } from "@shared/store/modules/asyncTask";
import { useAuthStore } from "@shared/store/modules/auth";
// 副作用 import：注册异步任务 handler，需在 restore() 之前完成；轮询走 /customer/asyncTask/batchDetail
import "@app/config/asyncTaskHandlers";

const auth = useAuthStore();
const currentUserStore = useCurrentUserStore();
const brandOptionsStore = useBrandOptionsStore();
const storeSitesStore = useStoreSitesStore();
const userOptionsStore = useUserOptionsStore();
const asyncTaskStore = useAsyncTaskStore();

asyncTaskStore.configure({ basePath: "/customer" });

async function bootstrapSession() {
    await currentUserStore.fetchIfNeeded();
    if (currentUserStore.forceChangePassword) {
        // 中间件会拦截 options / storeSites，避免业务错刷屏
        return;
    }
    asyncTaskStore.restore(currentUserStore.userDetail?.id);
    storeSitesStore.fetchIfNeeded();
    userOptionsStore.fetchIfNeeded();
}

function resetSession() {
    currentUserStore.reset();
    brandOptionsStore.reset();
    storeSitesStore.reset();
    userOptionsStore.reset();
}

onMounted(() => {
    if (auth.token) bootstrapSession();
});

watch(
    () => auth.token,
    token => {
        if (!token) resetSession();
        else bootstrapSession();
    },
);
</script>

<template>
    <el-config-provider :locale="zhCn">
        <router-view />
        <ForceChangePasswordHost v-if="auth.token" />
    </el-config-provider>
</template>
